import { render, staticRenderFns } from "./EntityDeleteDialog.vue?vue&type=template&id=1105e468&"
import script from "./EntityDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./EntityDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports